/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Export_Metrics_MenuInputs */

const en_speakers_export_metrics_menu = /** @type {(inputs: Speakers_Export_Metrics_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Speaker Metrics`)
};

const fr_speakers_export_metrics_menu = /** @type {(inputs: Speakers_Export_Metrics_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Speaker Metrics`)
};

const de_speakers_export_metrics_menu = /** @type {(inputs: Speakers_Export_Metrics_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Speaker Metrics`)
};

const it_speakers_export_metrics_menu = /** @type {(inputs: Speakers_Export_Metrics_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Speaker Metrics`)
};

const ru_speakers_export_metrics_menu = /** @type {(inputs: Speakers_Export_Metrics_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Speaker Metrics`)
};

const es_speakers_export_metrics_menu = /** @type {(inputs: Speakers_Export_Metrics_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Speaker Metrics`)
};

const zh_cn2_speakers_export_metrics_menu = /** @type {(inputs: Speakers_Export_Metrics_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Speaker Metrics`)
};

const ja_speakers_export_metrics_menu = /** @type {(inputs: Speakers_Export_Metrics_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Speaker Metrics`)
};

const hi_speakers_export_metrics_menu = /** @type {(inputs: Speakers_Export_Metrics_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Speaker Metrics`)
};

const pt_pt2_speakers_export_metrics_menu = /** @type {(inputs: Speakers_Export_Metrics_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Speaker Metrics`)
};

/**
* | output |
* | --- |
* | "Export Speaker Metrics" |
*
* @param {Speakers_Export_Metrics_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_export_metrics_menu = /** @type {((inputs?: Speakers_Export_Metrics_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Export_Metrics_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_export_metrics_menu(inputs)
	if (locale === "de") return de_speakers_export_metrics_menu(inputs)
	if (locale === "it") return it_speakers_export_metrics_menu(inputs)
	if (locale === "ru") return ru_speakers_export_metrics_menu(inputs)
	if (locale === "es") return es_speakers_export_metrics_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_export_metrics_menu(inputs)
	if (locale === "ja") return ja_speakers_export_metrics_menu(inputs)
	if (locale === "hi") return hi_speakers_export_metrics_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_export_metrics_menu(inputs)
	return en_speakers_export_metrics_menu(inputs)
});